import React from 'react';
import PropTypes from 'prop-types';
import { NeedToKnow as NeedToKnowSarsa, RequiredValidation, Stack, PlaceholderText } from 'sarsaparilla';
import get from 'lodash/get';

import { IS_NEED_TO_KNOW_CHECKED } from 'ui-permit/src/constants';
import { isMobile, scrollUp } from 'ui-permit/src/utils/utils';
import { PERMIT as permitProps } from 'ui-permit/src/props/permit';

import { NEED_TO_KNOW_CHECKED_PROP_PATH } from '../constants/propPaths';

const defaultDataBindingMap = {
  [NEED_TO_KNOW_CHECKED_PROP_PATH]: 'need_to_know_checked'
};

const defaultAttributes = {};

export default (issuanceShape, dataBindingsMap = defaultDataBindingMap, attributes = defaultAttributes) => {
  const dm = {...defaultDataBindingMap, ...dataBindingsMap};

  const NeedToKnow = ({
    name,
    permit,
    reservation,
    scrollToTopOnChecked,
    pActions,
    displayValidationError,
    isLoading,
    validation,
    shouldValidateOnBEOnly,
    addFieldRef,
    needToKnow = {
      text: '',
      division: {
        name: '',
      },
    },
  }) => {
    const checkedPath = dm[NEED_TO_KNOW_CHECKED_PROP_PATH];
    const isChecked = get(reservation, checkedPath);
    const needToKnowValidation = isChecked ? "true" : "";
    const handleChange = () => {
        pActions.updatePendingReservation(undefined, checkedPath, !isChecked);
        if (!isChecked && scrollToTopOnChecked && !isMobile.any()) {
            scrollUp();
        }
    };
    const onFormValidate = (isInvalid, error) => pActions.formValidationChange(
      `${reservation?.id}_${IS_NEED_TO_KNOW_CHECKED}`,
      isInvalid ? error : null
    );

    const isInvalid = () => {
      if(shouldValidateOnBEOnly) {
        return Boolean(get(validation, checkedPath));
      }
      return !isChecked && displayValidationError;
    }

    // TODO: Consider implementing the below logic in Sarsa in the future.
    const getSiteInfo = () => {
      const siteInfoAndNTK = get(permit, 'description.need_to_know_order');
      if (needToKnow.text !== '') {
        const needToKnowHtml = 
          `<p><strong>${needToKnow.division.name}</strong></p>${needToKnow.text}<hr /><p><strong>General Information</strong></p>`;

        return needToKnowHtml + siteInfoAndNTK;
      }
      return siteInfoAndNTK;
    }

    const renderNeedToKnowBody = () => {
      if (isLoading) {
        return (
          <NeedToKnowSarsa
            name={permit?.name || ""}
            isChecked={isChecked}
            isInvalid={isInvalid()}
            handleChange={handleChange} >
            <Stack space="lg">
              <PlaceholderText lines={2} />
              <PlaceholderText lines={2} />
            </Stack>
          </NeedToKnowSarsa>
        );
      }

      return (
        <>
          <NeedToKnowSarsa
            ref={addFieldRef?.(name, 0)}
            name={permit.name}
            needToKnow={needToKnow}
            siteInfo={getSiteInfo()}
            isChecked={isChecked}
            isInvalid={isInvalid()}
            handleChange={handleChange}
            checkboxId="need-to-know" />
          <RequiredValidation
            value={needToKnowValidation}
            displayInSummary
            onValidated={onFormValidate}
            controlLabel="Read and agree to the Need to Know information" />
        </>
      )
    }

    return (
      <div className="per-need-to-know-form per-section-group">
        {renderNeedToKnowBody()}
      </div>
    );
  }

  NeedToKnow.propTypes = {
    displayValidationError: PropTypes.bool.isRequired,
    pActions: PropTypes.shape({
      updatePendingReservation: PropTypes.func.isRequired,
      formValidationChange: PropTypes.func.isRequired
    }).isRequired,
    validation: PropTypes.shape({}).isRequired,
    scrollToTopOnChecked: PropTypes.bool,
    permit: permitProps,
    reservation: issuanceShape,
    isLoading: PropTypes.bool,
    shouldValidateOnBEOnly: PropTypes.bool,
    name: PropTypes.string,
    addFieldRef: PropTypes.func,
  };
  
  NeedToKnow.attributes = attributes;
  NeedToKnow.componentName = 'NeedToKnow';

  return NeedToKnow;
}
